import React from "react";
import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import useMutation from "../../../../hooks/useMutation";
import useNotification from "../../../../hooks/notification";
import { UPDATE_ASSET_MUTATION } from "../../../../constants/graphql/mutations";
import FormFieldsGroupedAsset from "../../../../views/capture/FormFieldsGroupedAsset";
import GroupedAssetBuilder from "./GroupedAssetBuilder";
import useRoles from "../../../../hooks/user/useRoles";
import useAuth from "../../../../hooks/useAuth";
import { useGroupedAssetsCollection } from "../../../../contexts/groupedAssetsCollection";
import { useGroupedAsset } from "../../../../contexts/grouped-asset";

export default function FormPageGroupedAsset({ disabled, type, currentAsset, onCloseModal, projectId, refetch }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const formProps = useFormikContext();
  const { notifyError } = useNotification();
  const isAdminOrManager = useRoles(["admin", "manager"]);
  const [updateAsset, { loading: loadingMutation }] = useMutation(UPDATE_ASSET_MUTATION);
  const { createImage } = useGroupedAssetsCollection();
  const { groupedAsset, loading: loadingGroupedAsset } = useGroupedAsset();
  
  const entity = groupedAsset?.id ? groupedAsset : currentAsset;

  const handleSubmitAction = ({
    variables,
    setSubmitting,
    setStatus,
    setErrors,
    submitAction,
    handleSubmit,
  }) => {
    handleSubmit();
    setSubmitting(true);

    return submitAction({
      variables: { ...variables, input: variables.input },
      onSuccess: () => {
        setSubmitting(false);
        setStatus({ success: true });
        refetch && refetch();
      },
      onFailure: errors => {
        setStatus({ success: false });
        setErrors(errors);
        notifyError(errors);
        setSubmitting(false);
      },
    });
  };

  const submitUpdateAsset = ({ values, ...props }) => () => {
    const variables = { id: entity?.id, input: values };

    return handleSubmitAction({ ...props, variables, submitAction: updateAsset });
  };

  return (
    <>
      <DialogContent sx={{ background: "#f4f6f8" }}>
        {(loadingMutation || loadingGroupedAsset) && (
          <Box py={1}>
            <LinearProgress className="mt-2" />
          </Box>
        )}
        {entity?.id && (
          <FormFieldsGroupedAsset
            disabledForm={disabled}
            type={type}
            asset={entity}
            loading={loadingMutation}
            updateAsset={updateAsset}
            createImage={createImage}
            setErrors={formProps.setErrors}
            errors={formProps.errors}
          />
        )}
        <Box mb={2} />
        <GroupedAssetBuilder
          disabled={disabled || !isAdminOrManager}
          entity={entity}
          projectId={projectId}
          refetch={refetch}
        />
        <Box mb={2} />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        {!disabled && (
          <Box>
            <Button sx={{ mr: disabled ? 0 : 1.5 }} variant="outlined" onClick={onCloseModal}>
              Close
            </Button>
            <Button variant="contained" color="primary" onClick={submitUpdateAsset(formProps)}>
              Save
            </Button>
          </Box>
        )}
      </DialogActions>
    </>
  );
}

